<script lang="ts" setup>
const theme = useTheming();
const route = useRoute();
const appConfig = useAppConfig();
const { locale: currentLocale } = useI18n();

const { script: zohoScript } = useZoho();

onMounted(() => {
  if (route.query.mvp) appConfig.useMVP = false;
});

// Provide a default floating player singleton to avoid undefined injections in consumers.
const existingFloatingPlayer = useFloatingPlayer();
if (!existingFloatingPlayer) {
  provideFloatingPlayer({
    open: () => {},
    close: () => {},
    togglePiPMode: () => {},
    video: ref(null),
    player: ref(null),
    playerState: ref(null),
    isDeleted: ref(false),
  });
}

useHead({
  // @ts-expect-error Look for htmlAttrs reactive types
  htmlAttrs: [
    {
      lang: computed(() => currentLocale.value || "en"),
      dir: computed(() => (currentLocale.value === "he" ? "rtl" : "ltr")),
    },
  ],
  charset: "utf-8",
  title: theme.siteName,
  titleTemplate: (title) => (title !== theme.siteName.value ? `${title} · ${theme.companyName.value}` : title),
  meta: [
    { name: "description", content: "Pixellot Play web project" },
    { property: "og:image", content: "https://you.pixellot.tv/wp/wp-content/uploads/air-camera-youth-soccer-game.jpg" },
    { name: "twitter:card", content: "summary_large_image" },
    { name: "twitter:site", content: "@Pixellotltd" },
    { name: "twitter:creator", content: "@Pixellotltd" },
  ],
  link: [{ rel: "icon", type: "image/png", href: theme.faviconURL }],
  script: [zohoScript].filter(Boolean),
});
</script>

<template>
  <div>
    <UModals />

    <NuxtLayout>
      <NuxtLoadingIndicator />
      <NuxtPage />
    </NuxtLayout>
    <RToast />
    <LazyVideoPlayerFloating />
  </div>
</template>

<style>
@import url("https://fonts.googleapis.com/css2?family=Red+Hat+Display:wght@300;400;500;600;700&display=swap");

html,
body,
#__nuxt {
  margin: 0;
  padding: 0;
  font-family: "Red Hat Display", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  --vjs-theme-pxl--primary: #009bc9;
}

.font-red-hat-display {
  font-family: "Red Hat Display", sans-serif;
}
</style>
